import { api } from '@/shared/api';

import { IBanner } from '../types/IBanner';
import { IPlace } from '../types/IPlace';

class BannersService {
  getAllBanners() {
    return api.get<{ banners: IBanner[] }>('/banners');
  }

  createBanner(
    data: Omit<IBanner, 'id' | 'createdAt' | 'updatedAt' | 'place'>
  ) {
    return api.post<IBanner>('/banners', data);
  }

  editBanner(
    id: number,
    data: Partial<Omit<IBanner, 'id' | 'createdAt' | 'updatedAt' | 'place'>>
  ) {
    return api.patch<IBanner>(`/banners/${id}`, data);
  }

  getSingleBanner(id: number) {
    return api.get<IBanner>(`/banners/${id}`);
  }

  getApplicationPlaces() {
    return api.get<{ applicationPlaces: IPlace[] }>('/applicationPlaces');
  }

  deleteBanner(id: number) {
    return api.delete(`/banners/${id}`);
  }

  getActiveBanners() {
    return api.get<IBanner[]>('/banners/active');
  }
}

const bannersService = new BannersService();
export default bannersService;
